export default "__VITE_ASSET__fdmqx$h7__"